import { Tag } from "pepsico-ds";
import { calculateRuntimeStatus, statusColorMap } from "./pointsOutcomeUtils";

const BoosterStatusTag = ({ startDate, endDate }) => {
  const status = calculateRuntimeStatus(startDate, endDate);
  return (
    <Tag
      text={status}
      color={statusColorMap[status]}
      type="filled"
      size="small"
      isCopyable={false}
    />
  );
};

export default BoosterStatusTag;
